import React, { useState, useEffect } from 'react';
import { Col, Form, Input, Row, Select, Typography, DatePicker, Button, Modal, Table, Rate } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import UploadButton from '../../../../../components/common/UploadButton';
import ExchangeDetailsDropdown from '../ExchangeD/ExchangeDetailsDropdown';
import InputSelect from '../../../../../components/common/InputSelect';
import PageContentHeader from '../../../../../components/common/PageContentHeader';
import { getLeadExchangeFollowUpStatusService, getSeaterMasterService } from '../../../../../services/master-services';
import { formatIndianCurrency } from '../../../../../utills/helpers';
// import { priceValidationFunction } from '../../../../../utills/helpers';

const { Title } = Typography;

const Step1VehicleInsuranceForm = ({
  leadViewDetails,
  setIsLoading,
  form,
  fileList,
  setFileList,
  fileList1,
  setFileList1,
  bankerList,
  setShowDetailsPage,
  dateFormat
}) => {
  const [followUpStatusList, setFollowUpStatusList] = useState([]);
  const [isValueHistoryModalVisible, setIsValueHistoryModalVisible] = useState(false);
  const [seaterOptions, setSeaterOptions] = useState([]);

  useEffect(() => {
    const fetchSeaters = async () => {
      try {
        const res = await getSeaterMasterService();
        const items = res?.data?.data || [];
        setSeaterOptions(items.map((item) => ({ value: item?.seater, label: item?.seater })));
      } catch (e) {
        setSeaterOptions([]);
      }
    };
    fetchSeaters();
  }, []);
  // Prepare data for the value history table
  const valueHistoryColumns = [
    {
      title: 'Exchange Value',
      dataIndex: 'exchange_value',
      key: 'exchange_value',
      render: (value) => formatIndianCurrency(value),
    },
    {
      title: 'Offered By',
      dataIndex: 'created_by',
      key: 'created_by',
      render: (createdBy) => createdBy?.full_name || 'N/A',
    },
  ];

  const valueHistoryData = leadViewDetails?.exchange_offered_value_history || [];

  useEffect(() => {
    const getFollowUpStatus = async () => {
      try {
        const response = await getLeadExchangeFollowUpStatusService();
        if (response.data.status === 200) {
          setFollowUpStatusList(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching follow up status:', error);
      }
    };
    getFollowUpStatus();
  }, []);

  // Check if Pre Final Assessment (stage 6) or Final Assessment (stage 7) is in progress
  const preFinalAssessmentInProgress = leadViewDetails?.exchange_stage_history?.filter(stage => 
    (stage.lead_exchange_stage_id === 6 && stage.status === 1)
  ).length > 0;
  const finalAssessmentInProgress = leadViewDetails?.exchange_stage_history?.filter(stage => 
    (stage.lead_exchange_stage_id === 7 && stage.status === 1)
  ).length > 0;
  const showTransferAndCustomerAgreement = preFinalAssessmentInProgress || finalAssessmentInProgress;

  return (
    <>
    <div>
      {/* Procurement Details Section - Same as original */}
      {leadViewDetails?.exchange_vehicle_detail?.vehicle_procured === 'No' &&
        leadViewDetails?.exchange_vehicle_detail?.is_evaluated === 1 ? (
        <div>
          <PageContentHeader
            title={
              leadViewDetails?.exchange_vehicle_detail?.is_vehicle_booked === 1 ? 'Procurement Details' : ''
            }
            headerRight={
              <Button type='primary' className='secondary-button' onClick={() => setShowDetailsPage(true)}>
                Evaluation Details
              </Button>
            }
          />
          {leadViewDetails?.exchange_vehicle_detail?.is_vehicle_booked === 1 && (
            <Row gutter={20}>
              <Col xl={8} lg={8} md={12} sm={24} xs={24}>
                <Form.Item label='Copy of RC' name='copy_of_rc'>
                  <UploadButton
                    name='copy_of_rc'
                    fileList={fileList}
                    setFileList={setFileList}
                    fileType={['image/jpeg', 'image/png']}
                    fileSizeLimit={5}
                    hideDeleteIcon={true}
                  />
                </Form.Item>
              </Col>
              <Col xl={8} lg={8} md={12} sm={24} xs={24}>
                <Form.Item label='Copy of Customer Agreement' name='copy_of_customer_agreement'>
                  <UploadButton
                    name='copy_of_customer_agreement'
                    fileList={fileList}
                    setFileList={setFileList}
                    fileType={['image/jpeg', 'image/png']}
                    fileSizeLimit={5}
                    documentType='copy_of_customer_agreement'
                    hideDeleteIcon={true}
                  />
                </Form.Item>
              </Col>
              
            </Row>
          )}
        </div>
      ) : (
        ''
      )}

      {/* Vehicle & Insurance Details Section */}
      <div>
        <div className='d-flex justify-content-between align-items-center'>
          <Title level={4} className='mb-3'>
            Vehicle & Insurance Details
          </Title>
        </div>

        {/* Vehicle Details */}
        <Title level={5} className='mb-3'>Vehicle Details</Title>
        <Row gutter={[16, 16]} className='mb-3'>
          <ExchangeDetailsDropdown setIsLoading={setIsLoading} form={form} leadViewDetails={leadViewDetails} />
         
          {/* RC Number */}
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='RC NUMBER'
              name='rc_number'
              initialValue={leadViewDetails?.exchange_vehicle_detail?.rc_number}
              rules={[{ required: true, message: 'Please input RC number' }]}
            >
              <Input placeholder='RC Number' className='form-control-ant' maxLength={20} />
            </Form.Item>
          </Col>

          {/* Emission Type */}
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='Emission Type'
              name='emission_type'
              initialValue={leadViewDetails?.exchange_vehicle_detail?.emission_type}
              rules={[{ required: true, message: 'Please select emission type' }]}
            >
              <Select className='form-control-ant' placeholder='Select Emission Type'>
                 <Select.Option value='BS2'>BS2</Select.Option>
                  <Select.Option value='BS3'>BS3</Select.Option>
                <Select.Option value='BS4'>BS4</Select.Option>
                <Select.Option value='BS6'>BS6</Select.Option>
              </Select>
            </Form.Item>
          </Col>

          {/* Warranty Applicability */}
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='Warranty Applicability'
              name='warranty_applicability'
              initialValue={leadViewDetails?.exchange_vehicle_detail?.warranty_applicability}
              rules={[{ required: true, message: 'Please select warranty applicability' }]}
            >
              <Select className='form-control-ant' placeholder='Select Warranty Applicability'>
                <Select.Option value='In Warranty'>In Warranty</Select.Option>
                <Select.Option value='Out of Warranty'>Out of Warranty</Select.Option>
                <Select.Option value='Unknown'>Unknown</Select.Option>
              </Select>
            </Form.Item>
          </Col>

          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='Number of Owners'
              name='no_of_owners'
              rules={[
                {
                  required: true,
                  message: 'Please input number of owners',
                },
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (!/^\d+$/.test(value)) {
                      return Promise.reject('Please enter a valid number');
                    }
                    const num = parseInt(value, 10);
                    if (num < 1) {
                      return Promise.reject('Number of owners must be at least 1');
                    }
                    if (num > 10) {
                      return Promise.reject('Number of owners cannot exceed 10');
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input 
                placeholder='Number of Owners' 
                className='form-control-ant' 
                type='number' 
                min={1} 
                max={10} 
                onKeyDown={(e) => { if (['e','E','+','-','.','ArrowUp','ArrowDown'].includes(e.key)) e.preventDefault(); }}
                onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, ''); }}
              />
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='VIN Number'
              name='vin_number'
              rules={[
                {
                  required: true,
                  message: 'Please input VIN number',
                },
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(value)) {
                      return Promise.reject('Please enter a valid 17-character VIN number');
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input placeholder='VIN Number' className='form-control-ant' maxLength={17} />
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='RC Book Type'
              name='rc_book_type'
              rules={[
                {
                  required: true,
                  message: 'Please select RC book type',
                },
              ]}
            >
              <Select className='form-control-ant' placeholder='Select RC Book Type'>
                <Select.Option value='Original'>Original</Select.Option>
                <Select.Option value='Reregistered'>Reregistered</Select.Option>
                <Select.Option value='DRC/FRC'>DRC/FRC</Select.Option>
                <Select.Option value='LPG Endorsed in RC'>LPG Endorsed in RC</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='Registration Date'
              name='registration_date'
              rules={[
                {
                  required: true,
                  message: 'Please select registration date',
                },
              ]}
              getValueFromEvent={(date) => date}
              getValueProps={(value) => ({
                value: value && dayjs.isDayjs(value) ? value : null
              })}
            >
              <DatePicker
                format={dateFormat}
                allowClear
                placeholder="Select Registration Date"
                disabledDate={(current) => current && current > dayjs().endOf('day')}
              />
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='Reregistered/Migrated'
              name='reregistered_migrated'
              rules={[
                {
                  required: true,
                  message: 'Please select reregistered/migrated status',
                },
              ]}
            >
              <Select className='form-control-ant' placeholder='Yes/No' defaultValue='No'>
                <Select.Option value='Yes'>Yes</Select.Option>
                <Select.Option value='No'>No</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='Engine Capacity'
              name='engine_capacity'
              rules={[
                {
                  required: false,
                  message: '',
                },
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                      return Promise.reject('Please enter a valid engine capacity');
                    }
                    const num = parseFloat(value);
                    if (num <= 0) {
                      return Promise.reject('Engine capacity must be greater than 0');
                    }
                    if (num > 10000) {
                      return Promise.reject('Engine capacity cannot exceed 10000');
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input placeholder='Engine Capacity' className='form-control-ant' type='number' min={0} max={10000} onKeyDown={(e) => { if (['e','E','+','-'].includes(e.key)) e.preventDefault(); }} />
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='Number of Cylinders'
              name='no_of_cylinders'
              rules={[
                {
                  required: false,
                  message: '',
                },
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (!/^\d+$/.test(value)) {
                      return Promise.reject('Please enter a valid number');
                    }
                    const num = parseInt(value, 10);
                    if (num < 1) {
                      return Promise.reject('Cylinders must be at least 1');
                    }
                    if (num > 16) {
                      return Promise.reject('Cylinders cannot exceed 16');
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input 
                placeholder='Number of Cylinders' 
                className='form-control-ant' 
                type='number' 
                min={1} 
                max={16} 
                onKeyDown={(e) => { if (['e','E','+','-','.','ArrowUp','ArrowDown'].includes(e.key)) e.preventDefault(); }}
                onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, ''); }}
              />
            </Form.Item>
          </Col>
          <Col  xl={4} md={8} sm={24} xs={24}>
                      <Form.Item
                        label='Number of Seats'
                        name='no_of_seats'
                        rules={[{ required: false, message: '' }]}
                        initialValue={leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.no_of_seats || undefined}
                      >
                        <Select
                          className='form-control-ant'
                          placeholder='Select seats'
                          size='small'
                          options={seaterOptions}
                        />
                      </Form.Item>
                  </Col>
          
        </Row>
        <Row gutter={[16, 16]}>
          {/* Rating of Car */}
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='Rating of Car'
              name='car_rating'
              initialValue={leadViewDetails?.exchange_vehicle_detail?.car_rating}
              rules={[{ required: true, message: 'Please select car rating' }]}
            >
              <Rate count={5} allowClear={false} />
            </Form.Item>
          </Col>
          </Row>      
        <Row gutter={[16, 16]} className='mb-3'>
        <Col xl={8} md={12} sm={24} xs={24}>
            <div style={{ 
              border: '1px solid #d9d9d9', 
              borderRadius: '6px', 
              padding: '12px',
              backgroundColor: '#fafafa'
            }}>
              <Form.Item
                label='Odometer'
                name='odometer'
                rules={[
                  {
                    required: true,
                    validator: (_, value) => {
                      if (!value) {
                        return Promise.reject(new Error('Please input your odometer details'));
                      } else if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                        return Promise.reject(new Error('The input must be numeric'));
                      } else if (value?.length < 2) {
                        return Promise.reject(new Error('The input must be at least 2 digits long'));
                      } else if (value?.length > 10) {
                        return Promise.reject(new Error('Odometer reading cannot be more than 10 digits'));
                      } else if (/\s/.test(value)) {
                        return Promise.reject(new Error('The input must not contain whitespace'));
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
                style={{ marginBottom: '8px' }}
              >
                <Input placeholder='Odometer' className='form-control-ant' maxLength={10} />
              </Form.Item>
              <Form.Item
                label={<span style={{ fontSize: '11px' }}>Odometer File</span>}
                name='odometer_document'
                rules={[
                  {
                    required: true,
                    message: 'Please upload odometer file',
                    validator: () => {
                      // Check if file exists in fileList
                      if (fileList.odometer_document && fileList.odometer_document.length > 0) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Please upload odometer file'));
                    }
                  },
                ]}
                style={{ marginBottom: '0' }}
              >
                <UploadButton
                  name='odometer_document'
                  fileList={fileList}
                  setFileList={setFileList}
                  fileType={['image/jpeg', 'image/png']}
                  fileSizeLimit={5}
                  hideDeleteIcon={true}
                />
              </Form.Item>
            </div>
          </Col>
          <Col xl={8} md={12} sm={24} xs={24}>
            <div style={{ 
              border: '1px solid #d9d9d9', 
              borderRadius: '6px', 
              padding: '12px',
              backgroundColor: '#fafafa'
            }}>
              <Form.Item
                label='Engine Number'
                name='engine_number'
                rules={[
                  {
                    required: false,
                    message: '',
                  },
                ]}
                style={{ marginBottom: '8px' }}
              >
                <Input placeholder='Engine Number' className='form-control-ant' maxLength={30} />
              </Form.Item>
              <Form.Item
                label={<span style={{ fontSize: '11px' }}>Engine Number Document</span>}
                name='engine_number_document'
                rules={[
                  {
                    required: false,
                    message: '',
                    validator: () => {
                      // Check if file exists in fileList
                      if (fileList.engine_number_document && fileList.engine_number_document.length > 0) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Please upload engine number document'));
                    }
                  },
                ]}
                style={{ marginBottom: '0' }}
              >
                <UploadButton
                  name='engine_number_document'
                  fileList={fileList}
                  setFileList={setFileList}
                  fileType={['image/jpeg', 'image/png']}
                  fileSizeLimit={5}
                  hideDeleteIcon={true}
                />
              </Form.Item>
            </div>
          </Col>
          <Col xl={8} md={8} sm={24} xs={24}>
            <div style={{ border: '1px solid #f0f0f0', borderRadius: '6px', padding: '12px', backgroundColor: '#fafafa' }}>
              <Form.Item
                label={<span style={{ fontSize: '12px', fontWeight: '500' }}>VIN Plate Available</span>}
                name='vin_plate_available'
                style={{ marginBottom: '8px' }}
              >
                <Select className='form-control-ant' placeholder='Yes/No' size='small' defaultValue='No'>
                  <Select.Option value='Yes'>Yes</Select.Option>
                  <Select.Option value='No'>No</Select.Option>
                </Select>
              </Form.Item>

              {/* Conditional VIN Plate Document Field */}
              <Form.Item dependencies={['vin_plate_available']} noStyle>
                {({ getFieldValue }) => {
                  const vinPlateAvailable = getFieldValue('vin_plate_available');
                  return vinPlateAvailable === 'Yes' ? (
                    <Form.Item
                      label={<span style={{ fontSize: '11px' }}>VIN Plate Document</span>}
                      name='vin_plate_document'
                      style={{ marginBottom: '0' }}
                      rules={[
                        {
                          required: true,
                          message: 'Please upload VIN plate document',
                          validator: () => {
                            // Check if file exists in fileList
                            if (fileList.vin_plate_document && fileList.vin_plate_document.length > 0) {
                              return Promise.resolve();
                            }
                            return Promise.reject(new Error('Please upload VIN plate document'));
                          }
                        },
                      ]}
                    >
                      <UploadButton
                        name='vin_plate_document'
                        fileList={fileList}
                        setFileList={setFileList}
                        fileType={['image/jpeg', 'image/png']}
                        fileSizeLimit={5}
                        hideDeleteIcon={true}
                      />
                    </Form.Item>
                  ) : null;
                }}
              </Form.Item>
            </div>
          </Col>


        </Row>
        <div className='h-line'>&nbsp;</div>

        {/* HP Entry and Related Fields */}
        <Title level={5} className='mb-3'>HP Entry Details</Title>
        <Row gutter={[16, 16]} className='mb-3'>
          <Col xl={8} lg={12} md={24} sm={24} xs={24}>
            <div style={{ border: '1px solid #f0f0f0', borderRadius: '6px', padding: '12px', backgroundColor: '#fafafa' }}>
              <Form.Item
                label={<span style={{ fontSize: '12px', fontWeight: '500' }}>HP Entry</span>}
                name='hp_entry'
                style={{ marginBottom: '8px' }}
                rules={[{ required: true, message: 'Please select HP Entry' }]}

              >
                <Select className='form-control-ant' placeholder='Yes/No/Cancelled' size='small'>
                  <Select.Option value='Yes'>Yes</Select.Option>
                  <Select.Option value='No'>No</Select.Option>
                  <Select.Option value='Cancelled'>Cancelled</Select.Option>
                </Select>
              </Form.Item>

              {/* Conditional NOC Available and Bank Fields */}
              <Form.Item dependencies={['hp_entry']} noStyle>
                {({ getFieldValue }) => {
                  const hpEntry = getFieldValue('hp_entry');
                  return hpEntry === 'Yes' ? (
                    <Row gutter={[8, 0]}>
                      <Col span={12}>
                        <Form.Item
                          label={<span style={{ fontSize: '11px' }}>NOC Available</span>}
                          name='noc_available'
                          rules={[
                            {
                              required: true,
                              message: 'Please select NOC availability',
                            },
                          ]}
                          style={{ marginBottom: '0' }}
                        >
                          <Select className='form-control-ant' placeholder='Yes/No' size='small'>
                            <Select.Option value='Yes'>Yes</Select.Option>
                            <Select.Option value='No'>No</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          label={<span style={{ fontSize: '11px' }}>Bank</span>}
                          name='hp_bank_id'
                          rules={[
                            {
                              required: true,
                              message: 'Please select bank',
                            },
                          ]}
                          style={{ marginBottom: '0' }}
                        >
                          <InputSelect
                            allowClear
                            placeholder='Select Bank'
                            options={bankerList}
                            optionName={'name'}
                            className='form-control-ant'
                            showSearch
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  ) : null;
                }}
              </Form.Item>
            </div>
          </Col>
        </Row>
        <div className='h-line'>&nbsp;</div>

        {/* Additional Vehicle Details - 3 cols on xl (1920) to avoid truncation on laptop */}
        <Title level={5} className='mb-3'>Additional Vehicle Details</Title>
        <Row gutter={[16, 16]} className='mb-3'>
          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              label='Original Invoice Available'
              name='original_invoice_available'
            >
              <Select className='form-control-ant' placeholder='Yes/No' defaultValue='No'>
                <Select.Option value='Yes'>Yes</Select.Option>
                <Select.Option value='No'>No</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              label='AC Configuration'
              name='ac_configuration'
              rules={[
                {
                  required: false,
                  message: '',
                },
              ]}
            >
              <Select className='form-control-ant' placeholder='Select AC Configuration'>
                <Select.Option value='Single'>Single</Select.Option>
                <Select.Option value='Dual'>Dual</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              label="Owner's Manual Available"
              name='owners_manual_available'
            >
              <Select className='form-control-ant' placeholder='Yes/No' defaultValue='No'>
                <Select.Option value='Yes'>Yes</Select.Option>
                <Select.Option value='No'>No</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              label='Tools Available'
              name='tools_available'
            >
              <Select className='form-control-ant' placeholder='Yes/No' defaultValue='No'>
                <Select.Option value='Yes'>Yes</Select.Option>
                <Select.Option value='No'>No</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              label='Service History Available'
              name='service_history_available'
            >
              <Select className='form-control-ant' placeholder='Yes/No' defaultValue='No'>
                <Select.Option value='Yes'>Yes</Select.Option>
                <Select.Option value='No'>No</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              label='Legal Case Present'
              name='legal_case_present'
            >
              <Select className='form-control-ant' placeholder='Yes/No' defaultValue='No'>
                <Select.Option value='Yes'>Yes</Select.Option>
                <Select.Option value='No'>No</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>


        <Row gutter={[16, 16]} className='mb-3'>
          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              label='Last Service Date'
              name='last_service_date'
              getValueFromEvent={(date) => date}
              getValueProps={(value) => ({
                value: value && dayjs.isDayjs(value) ? value : null
              })}
            >
              <DatePicker
                format={dateFormat}
                allowClear
                placeholder="Select Last Service Date"
                disabledDate={(current) => current && current > dayjs().endOf('day')}
              />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              label='Customer Type'
              name='customer_type'
              rules={[
                {
                  required: true,
                  message: 'Please select customer type',
                },
              ]}
            >
              <Select className='form-control-ant' placeholder='Select Customer Type'>
                <Select.Option value='Individual'>Individual</Select.Option>
                <Select.Option value='Corporate'>Corporate</Select.Option>
                <Select.Option value='Business'>Business</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              label='Name as on RC Card'
              name='name_as_on_rc_card'
              rules={[
                {
                  required: true,
                  message: 'Please input name as on RC card',
                },
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (!/^[a-zA-Z\s]+$/.test(value)) {
                      return Promise.reject('Name should contain only alphabets and spaces');
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input placeholder='Name as on RC Card' className='form-control-ant' maxLength={50} />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              label='Expected Price'
              name='expected_price'
              rules={[
                {
                  required: true,
                  message: 'Please input your expected price',
                },
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (!/^\d+$/.test(value)) {
                      return Promise.reject('Please enter a valid number');
                    }
                    const num = parseInt(value, 10);
                    if (num < 0) {
                      return Promise.reject('Expected Price cannot be negative');
                    }
                    if (num > 9999999999) {
                      return Promise.reject('Expected Price is too large');
                    }
                    return Promise.resolve();
                  },
                  
                }),
              ]}
            >
              <Input 
                placeholder='Expected Price' 
                className='form-control-ant' 
                type='number' 
                min={0} max={9999999999}
                onKeyDown={(e) => { 
                  if (['e','E','+','-','.','ArrowUp','ArrowDown'].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <div className='h-line'>&nbsp;</div>

        {/* Insurance Details */}
        <Title level={5} className='mb-3'>Insurance Details</Title>
        <Row gutter={[16, 16]} className='mb-3'>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='Insurance Type'
              name='insurance_type'
              rules={[
                {
                  required: true,
                  message: 'Please select insurance type',
                },
              ]}
            >
              <Select className='form-control-ant' placeholder='Select Insurance Type'>
                <Select.Option value='Third Party'>Third Party</Select.Option>
                <Select.Option value='Comprehensive'>Comprehensive</Select.Option>
                <Select.Option value='Lapsed'>Lapsed</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='Insurance Premium'
              name='insurance_premium'
              rules={[
                {
                  required: false,
                  message: '',
                },
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (!/^\d+$/.test(value)) {
                      return Promise.reject('Please enter a valid number');
                    }
                    const num = parseInt(value, 10);
                    if (num < 0) {
                      return Promise.reject('Insurance premium cannot be negative');
                    }
                    if (num > 9999999999) {
                      return Promise.reject('Insurance premium is too large');
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input 
                placeholder='Insurance Premium' 
                className='form-control-ant' 
                type='number' 
                min={0} max={9999999999}
                onKeyDown={(e) => { 
                  if (['e','E','+','-','.','ArrowUp','ArrowDown'].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
              />
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='Insurance Validity'
              name='insurance_validity'
              rules={[
                {
                  required: true,
                  message: 'Please input insurance validity',
                },
              ]}
              getValueFromEvent={(date) => date}
              getValueProps={(value) => ({
                value: value && dayjs.isDayjs(value) ? value : null
              })}
            >
              <DatePicker
                format={dateFormat}
                allowClear
                placeholder="Select Insurance Validity"
                disabledDate={(current) => current && current < dayjs().startOf('day')}
              />
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='Company Name'
              name='company_name'
              rules={[
                {
                  required: true,
                  message: 'Please input company name',
                },
              ]}
            >
              <Input placeholder='Company Name' className='form-control-ant' maxLength={100} />
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='Policy Number'
              name='policy_number'
              rules={[
                {
                  required: false,
                  message: '',
                },
                {
                  max: 30,
                  message: 'Policy number cannot exceed 30 characters',
                },
              ]}
            >
              <Input 
                placeholder='Policy Number' 
                className='form-control-ant' 
                maxLength={30}
                onInput={(e) => {
                  if (e.target.value && e.target.value.length > 30) {
                    e.target.value = e.target.value.slice(0, 30);
                  }
                }}
              />
            </Form.Item>
          </Col>

          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='IDV Value'
              name='idv_value'
              rules={[
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (!/^\d+$/.test(value)) {
                      return Promise.reject('Please enter a valid number');
                    }
                    const num = parseInt(value, 10);
                    if (num < 0) {
                      return Promise.reject('IDV value cannot be negative');
                    }
                    if (num > 9999999999) {
                      return Promise.reject('IDV value is too large');
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input 
                placeholder='IDV Value' 
                className='form-control-ant' 
                type='number' 
                min={0} max={9999999999}
                onKeyDown={(e) => { 
                  if (['e','E','+','-','.','ArrowUp','ArrowDown'].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]} className='mb-3'>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='NCB Details'
              name='ncb_details'
            >
              <Input placeholder='NCB Details' className='form-control-ant' maxLength={30} />
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='Insurance Cost'
              name='insurance_cost'
              initialValue={0}
              rules={[
                {
                  required: false,
                  message: '',
                },
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (!/^\d+$/.test(value)) {
                      return Promise.reject('Please enter a valid number');
                    }
                    const num = parseInt(value, 10);
                    if (num < 0) {
                      return Promise.reject('Insurance cost cannot be negative');
                    }
                    if (num > 9999999999) {
                      return Promise.reject('Insurance cost is too large');
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input 
                placeholder='Insurance Cost' 
                className='form-control-ant' 
                type='number' 
                min={0} max={9999999999}
                onKeyDown={(e) => { 
                  if (['e','E','+','-','.','ArrowUp','ArrowDown'].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
              />
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='Insurance Document'
              name='insurance_document'
              rules={[
                {
                  required: false,
                  message: '',
                  validator: () => {
                    // Check if file exists in fileList
                    if (fileList.insurance_document && fileList.insurance_document.length > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Please upload insurance document'));
                  }
                },
              ]}
            >
              <UploadButton
                name='insurance_document'
                fileList={fileList}
                setFileList={setFileList}
                fileType={['image/jpeg', 'image/png']}
                fileSizeLimit={5}
                hideDeleteIcon={true}
              />
            </Form.Item>
          </Col>
        </Row>
        <div className='h-line'>&nbsp;</div>

        {/* Additional Details */}
        <Title level={5} className='mb-3'>Additional Details</Title>
        <Row gutter={[16, 0]} className='mb-3'>
          <Col xl={8} lg={12} md={24} sm={24} xs={24}>
            <div style={{ border: '1px solid #f0f0f0', borderRadius: '6px', padding: '12px', backgroundColor: '#fafafa', marginBottom:'30px' }}>
              <Form.Item
                label={<span style={{ fontSize: '12px', fontWeight: '500' }}>City Registrations/Documents</span>}
                name='city_registrations_document'
                style={{ marginBottom: '8px' }}
              >
                <Select className='form-control-ant' placeholder='Yes/No' size='small' defaultValue='No'>
                  <Select.Option value='Yes'>Yes</Select.Option>
                  <Select.Option value='No'>No</Select.Option>
                </Select>
              </Form.Item>

              {/* Conditional Cost and File Fields */}
              <Form.Item dependencies={['city_registrations_document']} noStyle>
                {({ getFieldValue }) => {
                  const cityRegistrations = getFieldValue('city_registrations_document');
                  return cityRegistrations === 'Yes' ? (
                    <Row gutter={[8, 0]}>
                      <Col span={12}>
                        <Form.Item
                          label={<span style={{ fontSize: '11px' }}>Cost</span>}
                          name='city_registrations_document_cost'
                          initialValue={0}
                          rules={[
                            {
                              required: true,
                              message: 'Please input city registrations/documents cost',
                            },
                            () => ({
                              validator(_, value) {
                                if (!value) {
                                  return Promise.resolve();
                                }
                                if (!/^\d{1,10}(\.\d{1,2})?$/.test(value)) {
                                  return Promise.reject('Please enter a valid cost');
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                          style={{ marginBottom: '0' }}
                        >
                          <Input placeholder='Cost' className='form-control-ant' type='number' size='small' min={0} max={9999999999} onKeyDown={(e) => { if (['e','E','+','-'].includes(e.key)) e.preventDefault(); }} />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          label={<span style={{ fontSize: '11px' }}>File</span>}
                          name='city_registrations_document_file'
                          rules={[
                            {
                              required: true,
                              message: 'Please upload city registrations/documents file',
                              validator: () => {
                                // Check if file exists in fileList
                                if (fileList.city_registrations_document_file && fileList.city_registrations_document_file.length > 0) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(new Error('Please upload city registrations/documents file'));
                              }
                            },
                          ]}
                          style={{ marginBottom: '0' }}
                        >
                          <UploadButton
                            name='city_registrations_document_file'
                            fileList={fileList}
                            setFileList={setFileList}
                            fileType={['image/jpeg', 'image/png']}
                            fileSizeLimit={5}
                            hideDeleteIcon={true}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  ) : null;
                }}
              </Form.Item>
            </div>
          </Col>
          <Col xl={8} lg={12} md={24} sm={24} xs={24}>
            <div style={{ border: '1px solid #f0f0f0', borderRadius: '6px', padding: '12px', backgroundColor: '#fafafa' }}>
              <Form.Item
                label={<span style={{ fontSize: '12px', fontWeight: '500' }}>Accessories in Case of Repairs</span>}
                name='accessories_repairs'
                style={{ marginBottom: '8px' }}
              >
                <Select className='form-control-ant' placeholder='Yes/No' size='small' defaultValue='No'>
                  <Select.Option value='Yes'>Yes</Select.Option>
                  <Select.Option value='No'>No</Select.Option>
                </Select>
              </Form.Item>

              {/* Conditional Cost and File Fields */}
              <Form.Item dependencies={['accessories_repairs']} noStyle>
                {({ getFieldValue }) => {
                  const accessoriesRepairs = getFieldValue('accessories_repairs');
                  return accessoriesRepairs === 'Yes' ? (
                    <Row gutter={[8, 0]}>
                      <Col span={12}>
                        <Form.Item
                          label={<span style={{ fontSize: '11px' }}>Cost</span>}
                          name='accessories_repairs_cost'
                          initialValue={0}
                          rules={[
                            {
                              required: true,
                              message: 'Please input accessories in case of repairs cost',
                            },
                            () => ({
                              validator(_, value) {
                                if (!value) {
                                  return Promise.resolve();
                                }
                                if (!/^\d{1,10}(\.\d{1,2})?$/.test(value)) {
                                  return Promise.reject('Please enter a valid cost');
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                          style={{ marginBottom: '0' }}
                        >
                          <Input placeholder='Cost' className='form-control-ant' type='number' size='small' min={0} max={9999999999} onKeyDown={(e) => { if (['e','E','+','-'].includes(e.key)) e.preventDefault(); }} />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          label={<span style={{ fontSize: '11px' }}>File</span>}
                          name='accessories_repairs_document'
                          rules={[
                            {
                              required: true,
                              message: 'Please upload accessories in case of repairs file',
                              validator: () => {
                                // Check if file exists in fileList
                                if (fileList.accessories_repairs_document && fileList.accessories_repairs_document.length > 0) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(new Error('Please upload accessories in case of repairs file'));
                              }
                            },
                          ]}
                          style={{ marginBottom: '0' }}
                        >
                          <UploadButton
                            name='accessories_repairs_document'
                            fileList={fileList}
                            setFileList={setFileList}
                            fileType={['image/jpeg', 'image/png']}
                            fileSizeLimit={5}
                            hideDeleteIcon={true}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  ) : null;
                }}
              </Form.Item>
            </div>
          </Col>
          <Col xl={8} lg={12} md={24} sm={24} xs={24}>
            <div style={{ border: '1px solid #f0f0f0', borderRadius: '6px', padding: '12px', backgroundColor: '#fafafa' }}>
              <Form.Item
                label={<span style={{ fontSize: '12px', fontWeight: '500' }}>Foreclosure Loan</span>}
                name='foreclose_loan'
                rules={[
                  {
                    required: true,
                    message: 'Please select foreclosure loan',
                  },
                ]}
                style={{ marginBottom: '8px' }}
              >
                <Select className='form-control-ant' placeholder='Yes/No' size='small' defaultValue='No'>
                  <Select.Option value='Yes'>Yes</Select.Option>
                  <Select.Option value='No'>No</Select.Option>
                </Select>
              </Form.Item>

              {/* Conditional Foreclosure Amount Field */}
              <Form.Item dependencies={['foreclose_loan']} noStyle>
                {({ getFieldValue }) => {
                  const forecloseLoan = getFieldValue('foreclose_loan');
                  return forecloseLoan === 'Yes' ? (
                    <Form.Item
                      label={<span style={{ fontSize: '11px' }}>Foreclosure Amount Paid By dealer</span>}
                      name='foreclosure_amount_paid_by_dealer'
                      rules={[
                        {
                          required: true,
                          message: 'Please input foreclosure amount paid by dealer',
                        },
                        () => ({
                          validator(_, value) {
                            if (!value) {
                              return Promise.resolve();
                            }
                            if (!/^\d{1,10}(\.\d{1,2})?$/.test(value)) {
                              return Promise.reject('Please enter a valid amount');
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}
                      style={{ marginBottom: '0' }}
                    >
                      <Input placeholder='Foreclosure Amount Paid By dealer' className='form-control-ant' type='number' size='small' min={0} max={9999999999} onKeyDown={(e) => { if (['e','E','+','-'].includes(e.key)) e.preventDefault(); }} />
                    </Form.Item>
                  ) : null;
                }}
              </Form.Item>
            </div>
          </Col>


          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='One Time Road Tax Paid'
              name='one_time_road_tax_paid'
            >
              <Select className='form-control-ant' placeholder='Yes/No' defaultValue='No'>
                <Select.Option value='Yes'>Yes</Select.Option>
                <Select.Option value='No'>No</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='Bank'
              name='bank_id'
            >
              <Select className='form-control-ant' placeholder='Select Bank'>
                {bankerList?.map((bank) => (
                  <Select.Option key={bank.id} value={bank.id}>
                    {bank.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='Outstanding Loan'
              name='outstanding_loan'
              rules={[
                {
                  required: false,
                  message: '',
                },
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (!/^\d+$/.test(value)) {
                      return Promise.reject('Please enter a valid number');
                    }
                    const num = parseInt(value, 10);
                    if (num < 0) {
                      return Promise.reject('Outstanding loan cannot be negative');
                    }
                    if (num > 9999999999) {
                      return Promise.reject('Outstanding loan is too large');
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input 
                placeholder='Outstanding Loan' 
                className='form-control-ant' 
                type='number' 
                min={0} max={9999999999}
                onKeyDown={(e) => { 
                  if (['e','E','+','-','.','ArrowUp','ArrowDown'].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
              />
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='OBV Purchase Value'
              name='obv_purchase_value'
              rules={[
                {
                  required: true,
                  message: 'Please input OBV purchase value',
                },
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (!/^\d+$/.test(value)) {
                      return Promise.reject('Please enter a valid number');
                    }
                    const num = parseInt(value, 10);
                    if (num < 0) {
                      return Promise.reject('OBV purchase value cannot be negative');
                    }
                    if (num > 9999999999) {
                      return Promise.reject('OBV purchase value is too large');
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input 
                placeholder='OBV Purchase Value' 
                className='form-control-ant' 
                type='number' 
                min={0} max={9999999999}
                onKeyDown={(e) => { 
                  if (['e','E','+','-','.','ArrowUp','ArrowDown'].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
              />
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='Broker Valuation'
              name='broker_valuation'
              rules={[
                {
                  required: false,
                  message: '',
                },
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (!/^\d{1,10}(\.\d{1,2})?$/.test(value)) {
                      return Promise.reject('Please enter a valid broker valuation');
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input placeholder='Broker Valuation' className='form-control-ant' />
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label={
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <span>Value Offered</span>
                  <Button
                    type="text"
                    size="small"
                    icon={<InfoCircleOutlined />}
                    onClick={() => setIsValueHistoryModalVisible(true)}
                    style={{ 
                      padding: '0 4px',
                      height: 'auto',
                      fontSize: '12px'
                    }}
                  />
                </div>
              }
              name='value_offered'
              rules={[
                {
                  required: true,
                  message: 'Please input value offered',
                },
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (!/^\d{1,10}(\.\d{1,2})?$/.test(value)) {
                      return Promise.reject('Please enter a valid value offered');
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input placeholder='Value Offered' className='form-control-ant' />
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='Next Follow Up Date'
              name='next_follow_up_date'
              getValueFromEvent={(date) => date}
              getValueProps={(value) => ({
                value: value && dayjs.isDayjs(value) ? value : null
              })}
              rules={[
                {
                  required: true,
                  message: 'Please select next follow up date',
                },
              ]}
            >
              <DatePicker
                format={dateFormat}
                allowClear
                placeholder="Select Follow Up Date"
                disabledDate={(current) => current && current < dayjs().startOf('day')}
              />
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={24} xs={24}>
            <Form.Item
              label='Follow Up Status'
              name='exchange_followup_status_id'
              rules={[
                {
                  required: true,
                  message: 'Please select follow up status',
                },
              ]}
            >
              <Select className='form-control-ant' placeholder='Select Status'>
                {followUpStatusList.map((status) => (
                  <Select.Option key={status.id} value={status.id}>
                    {status.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]} className='mb-3'>

        </Row>
        <div className='h-line'>&nbsp;</div>

        {/* Photo Uploads */}
        <Title level={5} className='mb-3'>Photo Uploads</Title>
        <Row gutter={[16, 16]} className='mb-3'>
          {/* Show Transfer Document only for Pre Final Assessment (stage 6) or Final Assessment (stage 7) */}
          {showTransferAndCustomerAgreement && (
            <Col xl={6} lg={8} md={12} sm={24} xs={24}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ minWidth: '140px', display: 'inline-block' }}>
                  Transfer Document:
                </span>
                <Form.Item
                  name='transfer_document'
                  style={{ margin: 0, flex: 1 }}
                  rules={[
                    {
                      required: false,
                      message: '',
                      validator: () => {
                        if (fileList1.transfer_document && fileList1.transfer_document.length > 0) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Please upload transfer document'));
                      }
                    },
                  ]}
                >
                  <UploadButton
                    name='transfer_document'
                    fileList={fileList1}
                    setFileList={setFileList1}
                    fileType={['image/jpeg', 'image/png']}
                    fileSizeLimit={5}
                    documentType='transfer_document'
                    hideDeleteIcon={true}
                  />
                </Form.Item>
              </div>
            </Col>
          )}
          <Col xl={6} lg={8} md={12} sm={24} xs={24}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ minWidth: '140px', display: 'inline-block' }}>Loan Statement:</span>
              <Form.Item name='bank_statement' style={{ margin: 0, flex: 1 }}>
                <UploadButton
                  name='bank_statement'
                  fileList={fileList1}
                  setFileList={setFileList1}
                  fileType={['image/jpeg', 'image/png']}
                  fileSizeLimit={5}
                  documentType='bank-bank_statement'
                  hideDeleteIcon={true}
                />
              </Form.Item>
            </div>
          </Col>
          <Col xl={6} lg={8} md={12} sm={24} xs={24}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ minWidth: '140px', display: 'inline-block' }}>Copy of Front RC: <span style={{ color: 'red' }}>*</span> </span>
              <Form.Item name='copy_of_front_rc' style={{ margin: 0, flex: 1 }}
               rules={[
                  {
                    required: true,
                    message: 'Please upload copy of front RC',
                    validator: () => {
                      if (fileList.copy_of_front_rc && fileList.copy_of_front_rc.length > 0) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Please upload copy of front RC'));
                    }
                  },
                ]}
              >
                <UploadButton
                  name='copy_of_front_rc'
                  fileList={fileList}
                  setFileList={setFileList}
                  fileType={['image/jpeg', 'image/png']}
                  fileSizeLimit={5}
                  hideDeleteIcon={true}
                />
              </Form.Item>
            </div>
          </Col>
          <Col xl={6} lg={8} md={12} sm={24} xs={24}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ minWidth: '140px', display: 'inline-block' }}>Copy of Back RC : <span style={{ color: 'red' }}>*</span></span>
              <Form.Item name='copy_of_back_rc' style={{ margin: 0, flex: 1 }}
               rules={[
                  {
                    required: true,
                    message: 'Please upload copy of back RC',
                    validator: () => {
                      if (fileList.copy_of_back_rc && fileList.copy_of_back_rc.length > 0) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Please upload copy of back RC'));
                    }
                  },
                ]}
              >
                <UploadButton
                  name='copy_of_back_rc'
                  fileList={fileList}
                  setFileList={setFileList}
                  fileType={['image/jpeg', 'image/png']}
                  fileSizeLimit={5}
                  hideDeleteIcon={true}
                />
              </Form.Item>
            </div>
          </Col>
          {/* Show Customer Agreement only for Pre Final Assessment (stage 6) or Final Assessment (stage 7) */}
          {showTransferAndCustomerAgreement && (
            <Col xl={6} lg={8} md={12} sm={24} xs={24}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ minWidth: '140px', display: 'inline-block' }}>Customer Agreement:</span>
                <Form.Item name='copy_of_customer_agreement' style={{ margin: 0, flex: 1 }}>
                  <UploadButton
                    name='copy_of_customer_agreement'
                    fileList={fileList}
                    setFileList={setFileList}
                    fileType={['image/jpeg', 'image/png']}
                    fileSizeLimit={5}
                    documentType='copy_of_customer_agreement'
                    hideDeleteIcon={true}
                  />
                </Form.Item>
              </div>
            </Col>
          )}
        </Row>

        <Row gutter={[16, 16]} className='mb-3'>
          <Col xl={6} lg={8} md={12} sm={24} xs={24}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ minWidth: '140px', display: 'inline-block' }}>Exterior Front : <span style={{ color: 'red' }}>*</span></span>
              <Form.Item name='exterior_front' style={{ margin: 0, flex: 1 }}
                rules={[
                  {
                    required: true,
                    message: 'Please upload exterior front',
                    validator: () => {
                      if (fileList.exterior_front && fileList.exterior_front.length > 0) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Please upload exterior front'));
                    }
                  },
                ]}
              >
                <UploadButton
                  name='exterior_front'
                  fileList={fileList}
                  setFileList={setFileList}
                  fileType={['image/jpeg', 'image/png']}
                  fileSizeLimit={5}
                  hideDeleteIcon={true}
                />
              </Form.Item>
            </div>
          </Col>
          <Col xl={6} lg={8} md={12} sm={24} xs={24}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ minWidth: '140px', display: 'inline-block' }}>Exterior Left : <span style={{ color: 'red' }}>*</span></span>
              <Form.Item name='exterior_left' style={{ margin: 0, flex: 1 }}
                rules={[
                  {
                    required: true,
                    message: 'Please upload exterior left',
                    validator: () => {
                      if (fileList.exterior_left && fileList.exterior_left.length > 0) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Please upload exterior left'));
                    }
                  },
                ]}
              >
                <UploadButton
                  name='exterior_left'
                  fileList={fileList}
                  setFileList={setFileList}
                  fileType={['image/jpeg', 'image/png']}
                  fileSizeLimit={5}
                  hideDeleteIcon={true}
                />
              </Form.Item>
            </div>
          </Col>
          <Col xl={6} lg={8} md={12} sm={24} xs={24}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ minWidth: '140px', display: 'inline-block' }}>Exterior Right : <span style={{ color: 'red' }}>*</span></span>
              <Form.Item name='exterior_right' style={{ margin: 0, flex: 1 }}
                rules={[
                  {
                    required: true,
                    message: 'Please upload exterior right',
                    validator: () => {
                      if (fileList.exterior_right && fileList.exterior_right.length > 0) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Please upload exterior right'));
                    }
                  },
                ]}
              >
                <UploadButton
                  name='exterior_right'
                  fileList={fileList}
                  setFileList={setFileList}
                  fileType={['image/jpeg', 'image/png']}
                  fileSizeLimit={5}
                  hideDeleteIcon={true}
                />
              </Form.Item>
            </div>
          </Col>
          <Col xl={6} lg={8} md={12} sm={24} xs={24}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ minWidth: '140px', display: 'inline-block' }}>Exterior Back: <span style={{ color: 'red' }}>*</span> </span>
              <Form.Item name='exterior_back' style={{ margin: 0, flex: 1 }}
                rules={[
                  {
                    required: true,
                    message: 'Please upload exterior back',
                    validator: () => {
                      if (fileList.exterior_back && fileList.exterior_back.length > 0) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Please upload exterior back'));
                    }
                  },
                ]}
              >
                <UploadButton
                  name='exterior_back'
                  fileList={fileList}
                  setFileList={setFileList}
                  fileType={['image/jpeg', 'image/png']}
                  fileSizeLimit={5}
                  hideDeleteIcon={true}
                />
              </Form.Item>
            </div>
          </Col>
        </Row>

        <Row gutter={[16, 16]} className='mb-3'>
          <Col xl={6} lg={8} md={12} sm={24} xs={24}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ minWidth: '140px', display: 'inline-block' }}>Interior Front: <span style={{ color: 'red' }}>*</span> </span>
              <Form.Item name='interior_front' style={{ margin: 0, flex: 1 }}
                rules={[
                  {
                    required: true,
                    message: 'Please upload interior front',
                    validator: () => {
                      if (fileList.interior_front && fileList.interior_front.length > 0) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Please upload interior front'));
                    }
                  },
                ]}
              >
                <UploadButton
                  name='interior_front'
                  fileList={fileList}
                  setFileList={setFileList}
                  fileType={['image/jpeg', 'image/png']}
                  fileSizeLimit={5}
                  hideDeleteIcon={true}
                />
              </Form.Item>
            </div>
          </Col>
          <Col xl={6} lg={8} md={12} sm={24} xs={24}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ minWidth: '140px', display: 'inline-block' }}>Interior Back: <span style={{ color: 'red' }}>*</span> </span>
              <Form.Item name='interior_back' style={{ margin: 0, flex: 1 }}
                rules={[
                  {
                    required: true,
                    message: 'Please upload interior back',
                    validator: () => {
                      if (fileList.interior_back && fileList.interior_back.length > 0) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Please upload interior back'));
                    }
                  },
                ]}
              >
                <UploadButton
                  name='interior_back'
                  fileList={fileList}
                  setFileList={setFileList}
                  fileType={['image/jpeg', 'image/png']}
                  fileSizeLimit={5}
                  hideDeleteIcon={true}
                />
              </Form.Item>
            </div>
          </Col>
          <Col xl={6} lg={8} md={12} sm={24} xs={24}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ minWidth: '140px', display: 'inline-block' }}>Bonnet Open : <span style={{ color: 'red' }}>*</span> </span>
              <Form.Item name='bonnet_open' style={{ margin: 0, flex: 1 }}
                rules={[
                  {
                    required: true,
                    message: 'Please upload bonnet open',
                    validator: () => {
                      if (fileList.bonnet_open && fileList.bonnet_open.length > 0) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Please upload bonnet open'));
                    }
                  },
                ]}
              >
                <UploadButton
                  name='bonnet_open'
                  fileList={fileList}
                  setFileList={setFileList}
                  fileType={['image/jpeg', 'image/png']}
                  fileSizeLimit={5}
                  hideDeleteIcon={true}
                />
              </Form.Item>
            </div>
          </Col>
          <Col xl={6} lg={8} md={12} sm={24} xs={24}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ minWidth: '140px', display: 'inline-block' }}>Boot Open : <span style={{ color: 'red' }}>*</span> </span>
              <Form.Item name='boot_open' style={{ margin: 0, flex: 1 }}
                rules={[
                  {
                    required: true,
                    message: 'Please upload boot open',
                    validator: () => {
                      if (fileList.boot_open && fileList.boot_open.length > 0) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Please upload boot open'));
                    }
                  },
                ]}
              >
                <UploadButton
                  name='boot_open'
                  fileList={fileList}
                  setFileList={setFileList}
                  fileType={['image/jpeg', 'image/png']}
                  fileSizeLimit={5}
                  hideDeleteIcon={true}
                />
              </Form.Item>
            </div>
          </Col>
        </Row>
      </div>
    </div>

    {/* Value History Modal */}
    <Modal
      title="Exchange Value History"
      open={isValueHistoryModalVisible}
      onCancel={() => setIsValueHistoryModalVisible(false)}
      footer={[
        <Button key="close" onClick={() => setIsValueHistoryModalVisible(false)}>
          Close
        </Button>
      ]}
      width={'90%'}
      style={{ maxWidth: 600 }}
    >
      <Table
        columns={valueHistoryColumns}
        dataSource={valueHistoryData}
        rowKey="id"
        pagination={false}
        size="small"
      />
    </Modal>
    </>
  );
};

export default Step1VehicleInsuranceForm;
